import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  createOrder,
  formatYuan,
  getPublicConfig,
  resolvePriceCents,
  type PublicConfig,
  type Tier,
} from '../lib/api';

export default function CreateOrder() {
  const navigate = useNavigate();
  const [cfg, setCfg] = useState<PublicConfig | null>(null);
  const [tier, setTier] = useState<Tier>('standard');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const [cfgReady, setCfgReady] = useState(false);

  useEffect(() => {
    getPublicConfig()
      .then(setCfg)
      .catch(() => {
        setCfg(null);
        setError('无法加载价格配置，请稍后重试');
      })
      .finally(() => setCfgReady(true));
  }, []);

  async function onSubmit() {
    setBusy(true);
    setError('');
    try {
      const order = await createOrder(tier);
      navigate(`/order/${order.public_code}/pay`);
    } catch {
      setError('创建订单失败，请稍后重试');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="stack">
      <div className="work-card">
        <h2 className="type-display-md text-ink">选择制作档位</h2>
        <p className="type-body-md text-ink-secondary">价格来自站点公开配置，支付请按下一页闲鱼指引完成。</p>
      </div>

      <div className="tier-grid">
        <button
          type="button"
          className={`tier-card${tier === 'standard' ? ' selected' : ''}`}
          onClick={() => setTier('standard')}
        >
          <h3 className="type-display-md text-ink">标准档</h3>
          <p className="type-body-md text-ink-secondary">清晰庄重的纪念肖像，适合日常追思使用。</p>
          <p className="price">
            {cfgReady ? formatYuan(resolvePriceCents(cfg, 'standard')) : '…'}
          </p>
        </button>
        <button
          type="button"
          className={`tier-card${tier === 'deep' ? ' selected' : ''}`}
          onClick={() => setTier('deep')}
        >
          <h3 className="type-display-md text-ink">深度档</h3>
          <p className="type-body-md text-ink-secondary">更细致的润色与生成强度，适合重要纪念场合。</p>
          <p className="price">{cfgReady ? formatYuan(resolvePriceCents(cfg, 'deep')) : '…'}</p>
        </button>
      </div>

      {error ? <div className="error">{error}</div> : null}

      <div className="row">
        <button type="button" className="btn-primary" disabled={busy || !cfg} onClick={onSubmit}>
          {busy ? '创建中…' : '创建订单并去支付'}
        </button>
      </div>
    </section>
  );
}
